<template>
  <div class="page-maindiv">
    <!-- Filtri -->
    <b-sidebar id="sidebar-filters" body-class="display-block" header-class="font-title1" :title="$t('filtri_avanzati').toUpperCase()" width="600px" right backdrop>
      <div class="px-3 py-2 flex-column">
        <b-dropdown id="dropdown-1" block :text="$t('filtri_avanzati_facolta')" variant="outline-primary" class="ml-2 w-100" >
          <b-dropdown-item :active="searchFilter.area === ''" @click="searchFilter.area=''">
            <b-img blank style="margin-right: 0.5rem; width: 1em; height: 1.5rem" blankColor="transparent"></b-img>
            {{ $t('facolta_tutte') }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.area === '#DEDDD3'" @click="searchFilter.area='#DEDDD3'">
            <b-img blank style="margin-right: 0.5rem; width: 1em; height: 1.5rem" blankColor="#DEDDD3"></b-img>
            {{ $t('facolta_su') }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.area === '#A4C400'" @click="searchFilter.area='#A4C400'">
            <b-img blank style="margin-right: 0.5rem; width: 1em; height: 1.5rem" blankColor="#A4C400"></b-img>
            {{ $t('facolta_saa') }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.area === '#009932'" @click="searchFilter.area='#009932'">
            <b-img blank style="margin-right: 0.5rem; width: 1em; height: 1.5rem" blankColor="#009932"></b-img>
            {{ $t('facolta_st') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="px-3 py-2 flex-column">
        <b-dropdown id="dropdown-1" block :text="$t('tipi_media')" variant="outline-primary" class="ml-2 w-100" >
          <b-dropdown-item :active="searchFilter.mediaType === 'all'" @click="searchFilter.mediaType='all'">
            {{ $t('tipi_media_tutti') }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.mediaType === 'images'" @click="searchFilter.mediaType='images'">
            {{ $tc('tipi_media_immagini-n', 1) }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.mediaType === 'audio'" @click="searchFilter.mediaType='audio'">
            {{ $tc('tipi_media_audio-n', 1) }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.mediaType === 'video'" @click="searchFilter.mediaType='video'">
            {{ $tc('tipi_media_video-n', 1) }}
          </b-dropdown-item>
          <b-dropdown-item :active="searchFilter.mediaType === 'other'" @click="searchFilter.mediaType='other'">
            {{ $tc('tipi_media_altro-n', 1) }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </b-sidebar>
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('scavi') }}
        </div>
        <div class="area-top-subtitle" v-if="idStructure !== 0">
          {{ structureName }}
        </div>
      </div>
      <div class="area-description" v-html="pageDescription" v-if="!loading"></div>
      <!-- Area ricerca -->
      <div class="area-search" v-if="!loading">
        <b-icon :icon="(this.sort === 1) ? 'sort-alpha-down' : 'sort-alpha-down-alt'" aria-label="sort" style="margin-right: 15px; cursor: pointer" class="h2 pt-2" @click="setSort()"></b-icon>
        <b-input-group>
          <b-input-group-prepend style="height: 40px" is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="searchFilter.searchCollections" style="height: 40px" type="search" :placeholder="$t('filtro_semplice')"></b-form-input>
        </b-input-group>
      </div>
      <!-- Area cards -->
      <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
      <div class="results-cards">
        <b-card
            class="results-card"
            no-body
            border-variant="white"
            v-for="(collection, index) in filteredCollections"
            :key="collection.id"
            @mouseover="hoverCard(index)"
            @mouseout="hoverCard(-1)"
        >
            <div>
              <b-link :to="{name: 'assets', params: {idCollection: collection.id, previousPageLink: '/archaeological', previousPageTitle: $t('scavi')}}" style="text-decoration: none;color: #2c3e50;width: 100%">
                <b-card-img-lazy class="results-card-image" :class="{'selected': isCardSelected(index)}" :src="collection.immagine" :alt="collection.nome" top></b-card-img-lazy>
              </b-link>
            </div>
            <b-card-text class="results-card-num-results">
              <p class="mb-0">{{ collection.num_beni + " " + $tc("beni_visibili-n", collection.num_beni) }}</p>
              <div style="display: flex">
                <p class="mb-0">{{ collection.num_immagini }}<b-icon class="ml-1 mr-3" icon="image"></b-icon></p>
<!--                <p class="mb-0">{{ collection.num_audio }}<b-icon class="ml-1 mr-3" icon="headphones"></b-icon></p>-->
                <p class="mb-0">{{ collection.num_video }}<b-icon class="ml-1" icon="camera-reels"></b-icon></p>
<!--                <p class="mb-0">{{ collection.num_altro }}<b-icon class="ml-1" icon="box"></b-icon></p>-->
              </div>
            </b-card-text>
            <b-link :to="{name: 'assets', params: {idCollection: collection.id, previousPageLink: '/archaeological', previousPageTitle: $t('scavi')}}" style="text-decoration: none;color: #2c3e50" @mouseover="hoverCard(index)" @mouseout="hoverCard(-1)">
              <b-card-text class="results-card-title">
                {{ collection.nome }}
              </b-card-text>
            </b-link>
            <div class="results-card-color-div" :style=" 'background-color: ' + getStructureColor(collection.strutturaId) "></div>
            <b-card-text class="results-card-subtitle" :style="getStructureColor(collection.strutturaId) == null ? 'margin-left:10px' : ''">
              <b-link :to="{name: 'collections', params: {idStructure: collection.strutturaId, previousPageLink: '/archaeological', previousPageTitle: $t('scavi')}}" @mouseover="hoverStructure(index)" @mouseout="hoverStructure(-1)">
                <p class="mb-0">{{ getStructureName(collection.strutturaId) }}</p>
              </b-link>
            </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Archaeological',
  data: function() {
    return {
      pageDescriptionRecord: "",
      searchFilter: {
        searchCollections: '', // Stringa di ricerca
        area: '',
        mediaType: 'all',
      },
      structures: [], // Lista delle strutture
      collections: [], // Lista delle collezioni
      selectedCard: -1, // Collezione selezionata (hover)
      selectedStructure: -1, // Struttura selezionata (hover sulla struttura, per filtro al clic)
      sort: 1, // 1: AZ, -1: ZA
      loading: true,
    };
  },
  created() {
    this.fetchCollections()
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    filteredCollections() {
      const collections = this.collections;
      for (let collection in collections) {
        // Compila nome e descrizione
        collections[collection].nome = this.$utilities.getTranslation(collections[collection], "nome", this.$i18n.locale);
        collections[collection].claim = this.$utilities.getTranslation(collections[collection], "claim", this.$i18n.locale);
        collections[collection].descrizione = this.$utilities.getTranslation(collections[collection], "descrizione_breve", this.$i18n.locale);
      }

      let result = collections;
      // Filtro per struttura
      result = result.filter(collection => {
        if (collection.strutturaId == null || collection.nome == null)
          return false;
        // Presenza di filtro testuale
        return collection.nome.toLowerCase().includes(this.searchFilter.searchCollections.toLowerCase());
      });
      // Presenza di filtro su area
      if (!this.$utilities.isEmpty(this.searchFilter.area))
        result = result.filter(collection => {
          if (this.$utilities.isEmpty(collection.strutturaId))
            return false;
          else {
            const color = this.getStructureColor(collection.strutturaId);
            return !this.$utilities.isEmpty(color) && (color.toLowerCase() === this.searchFilter.area.toLowerCase());
          }
        });
      // Presenza di filtro su tipo media
      if (!this.$utilities.isEmpty(this.searchFilter.mediaType))
        result = result.filter(collection => {
          if (this.searchFilter.mediaType === "all")
            return true;
          else if (this.searchFilter.mediaType === "images")
            return collection.num_immagini > 0;
          else if (this.searchFilter.mediaType === "audio")
            return collection.num_audio > 0;
          else if (this.searchFilter.mediaType === "video")
            return collection.num_video > 0;
          else if (this.searchFilter.mediaType === "other")
            return collection.num_altro > 0;
        });


      return result.sort((a, b) => {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
          return this.sort;
        } else if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
          return -this.sort;
        } else
          return 0;
      });
    },
    structureName() {
      let idStructure = this.$route.params.idStructure;
      if (parseInt(idStructure) == 0)
        return "";
      else {
        let structures = this.structures;

        for (let structure in structures) {
          structures[structure].nome = this.$utilities.getTranslation(structures[structure], "nome", this.$i18n.locale);
          if (parseInt(structures[structure].id) === parseInt(idStructure))
            return structures[structure].nome;
        }
      }
      return "";
    },
    structureDescription() {
      let idStructure = this.$route.params.idStructure;
      if (parseInt(idStructure) == 0)
        return "";
      else {
        let structures = this.structures;
        for (let structure in structures) {
          structures[structure].descrizione = this.$utilities.getTranslation(structures[structure], "descrizione", this.$i18n.locale);
          if (parseInt(structures[structure].id) === parseInt(idStructure))
            return structures[structure].descrizione;
        }
      }
      return "";
    },
    idStructure() {
      let idStructure = this.$route.params.idStructure;
      let structureFound = false;
      for (let dep in this.structures) {
        if (parseInt(this.structures[dep].id) === parseInt(idStructure)) {
          structureFound = true;
        }
      }
      if (!structureFound)
        idStructure = 0;
      return idStructure;
    },
  },
  methods: {
    // Nome della struttura dato l'id
    getStructureName(idStructure) {
      if (parseInt(idStructure) == 0)
        return "";
      else {
        let structures = this.structures;
        for (let structure in structures) {
          structures[structure].nome = this.$utilities.getTranslation(structures[structure], "nome", this.$i18n.locale);
          if (parseInt(structures[structure].id) === parseInt(idStructure))
            return structures[structure].nome;
        }
      }
      return "";
    },
    // Colore dell'area di appartenenza di una struttura dato l'id
    getStructureColor(idStructure) {
      if (parseInt(idStructure) == 0)
        return "";
      else {
        let structures = this.structures;
        for (let structure in structures) {
          if (parseInt(structures[structure].id) === parseInt(idStructure))
            return structures[structure].colore_area;
        }
      }
      return "";
    },
    // Recupera le collezioni di scavi archeologici
    async fetchCollections() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'scavi'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      // Recupera tutti i dipartimenti
      const structuresData = await this.$client.getItems("dipartimenti", {fields: ["*", "traduzioni.*"], filter: {
        tipologia: {
          eq: 'dipartimento'
        }
      }});
      let structures = structuresData.data;
      this.structures = structures.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));

      // Recupera le collezioni
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["*", "traduzioni.*"], filter: {
          tipologia: {
            eq: 'scavo'
          }
        }
      });
      let collections = collectionsData.data;
      for (let coll in collections) {
        // Valorizza campo che punta alla struttura relativa
        for (let structure in structures) {
          if (structures[structure].id === collections[coll].id_dipartimento.id) {
            collections[coll].strutturaId = parseInt(structures[structure].id);
          }
        }

        const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});
        if (collections[coll].immagine != null) {
          const imageId = "" + collections[coll].immagine.id;
          const fileData = await this.$client.getFile(imageId);
          collections[coll].immagine = fileData;
          let file = fileData.data;
          const assetUrl = await this.$client.getAssetUrl(file.private_hash, {key: "directus-large-contain"});
          collections[coll].immagine = assetUrl;
        } else {
          collections[coll].immagine = defaultImageUrl;
        }
      }

      this.collections = collections.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
      this.loading = false;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isCardSelected (cardIndex) {
      return this.selectedCard === cardIndex
    },
    hoverStructure(selectedIndex) {
      this.selectedStructure = selectedIndex
    },
    isStructureSelected(structureIndex) {
      return this.selectedStructure === structureIndex
    },
    setSort() {
      this.sort = (this.sort === 1) ? -1 : 1;
    },
  }
}
</script>

<style>
</style>
